import "./Table.scss";
import TableRow from "./TableRow";

export default (props) => {
  return (
    props.data && (
      <table className="Table">
        <tbody>
          {props.data.map((row, i) => (
            <TableRow data={row} key={i} />
          ))}
        </tbody>
      </table>
    )
  );
};
